var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6668 22.7466C50.6668 27.901 40.7408 32.08 28.5002 32.08C16.2595 32.08 6.3335 27.901 6.3335 22.7466M50.6668 33.2466C50.6668 38.401 40.7408 42.58 28.5002 42.58C16.2595 42.58 6.3335 38.401 6.3335 33.2466M50.6668 13.4133C50.6668 18.5676 40.7408 22.7466 28.5002 22.7466C16.2595 22.7466 6.3335 18.5676 6.3335 13.4133C6.3335 8.25896 16.2595 4.07996 28.5002 4.07996C40.7408 4.07996 50.6668 8.25896 50.6668 13.4133Z",
    stroke: "#0B132B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 13.4133V43.7467C6.3335 48.901 16.2595 53.08 28.5002 53.08C40.7408 53.08 50.6668 48.901 50.6668 43.7467V13.4133",
    stroke: "#0B132B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.579956)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc5);
export default __webpack_public_path__ + "static/media/doc5.24e3e3c0f2918c2e6c4b192f2d206344.svg";
export { ForwardRef as ReactComponent };